import cabecalho from '@/components/global/Cabecalho/Cabecalho.vue'
import menuLateral from '@/components/global/MenuLateral/MenuLateral.vue'
import Util from '@/util'
import Mensagens from '@/util/mensagens'
import SpinnerProcessando from '@/components/layout/spinnerProcessamento/SpinnerProcessamento.vue'
import ContratoModalVerificaCancelamento from '@/views/recursos/ContratoModalVerificaCancelamento.vue'
import ContratoModalCancelamento from '@/views/recursos/ContratoModalCancelamento.vue'
import CancelamentoContrato from '@/views/recursos/CancelamentoContrato.vue'
import RecursosListagem from '@/views/recursos/RecursosListagem.vue'

export default {
  name: 'recursos',
  components: {
    cabecalho,
    SpinnerProcessando,
    menuLateral,
    ContratoModalVerificaCancelamento,
    ContratoModalCancelamento,
    RecursosListagem,
    CancelamentoContrato
  },
  computed: {
    recursosFiltrados () {
      return this.recursos.filter(recurso => this.collapseSelecionado === recurso.descricao)
    }
  },
  data () {
    return {
      flagsDeControle: {
        carregandoDados: {
          status: false,
          mensagem: ''
        }
      },
      isVencido: false,
      collapseSelecionado: null,
      temFaturaEmAtrasoDoContratoPrincipal: null,
      collapsedItems: [],
      informacoesContrato: [],
      recursos: []
    }
  },
  mounted () {
    this.obterRecursos()
  },
  methods: {
    async obterRecursos () { // Unico
      this.definirFlagCarregandoDados(true, Mensagens.carregandoDadosEdicao)
      try {
        const resposta = await this.axios.get(`/manager/conta/recursos-contrato`)
        this.recursos = resposta.data.retorno.dados.recursos
        this.informacoesContrato = resposta.data.retorno.dados.informacoes.contrato_principal
        this.temFaturaEmAtrasoDoContratoPrincipal = resposta.data.retorno.dados.temFaturaEmAtrasoDoContratoPrincipal
        if (this.informacoesContrato.data_vencimento < this.$date().format('YYYY-MM-DD')) {
          this.isVencido = true
        }
      } catch (e) {
        Util.criarAlertaToastDeErro(this, 'Aviso', Mensagens.falhaServidorCarregandoDados)
      }
      this.definirFlagCarregandoDados(false, Mensagens.carregandoDadosEdicao)
    },
    formatarValorMonetario (valor) {
      if (Util.valorEhNulo(valor)) return 'R$ 0,00'
      return Util.formatarValorMonetarioComCifrao(valor)
    },
    abrirCollapse (descricao) {
      this.collapseSelecionado = this.collapseSelecionado === descricao ? null : descricao
    },
    definirFlagCarregandoDados (status, mensagem) {
      this.flagsDeControle.carregandoDados.status = status
      this.flagsDeControle.carregandoDados.mensagem = mensagem
    }
  }
}
